// recommended

export enum RecommendType {
  Hospital = 1,
  Doctor = 2,
  Disease = 4,
  Activity = 10,
}
